import { DeleteOutlined, EyeOutlined, RedoOutlined, SettingOutlined } from "@ant-design/icons";
import { ConfigProvider, Flex, Input, Pagination, Table, TableColumnsType, TableProps, Tag } from "antd";
import { clamationCircle, dropdownTrigger, warning_delete } from "../../../../components/ExportImgFigma";
import { getListRecycleGroupCustomer, Item } from "../../../../api/recycleCustomer/recycleCustomerApi";
import useLoading from "../../../../hook/useLoading";
import useToast from "../../../../hook/useToast";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import useDebounce from "../../../../hook/useDebounce";
import * as recycleCustomerApi from "../../../../api/recycleCustomer/recycleCustomerApi"
import { PaginationProps } from "antd/lib";
import ModalRestoreCustomer from "./Modal/ModalRestoreCustomer";
import ModalDeleteManager from "../../../../components/ModalDeleteManager";
import viVN from 'antd/locale/vi_VN';
import { dataPagination } from "../../../../until";
import { deleteGroup } from "../../../../api/groupCustomer/groupCustomerApi";
import { useSelector } from "react-redux";
import { selectorInfoUser } from "../../../../store/slices/infoUserSlice";
import GroupCustomerTypeTree from "../../CustomerGroup/Component/GroupCustomerTypeTree";
import RecycleGroupCustomerTypeTable from "./RecycleGroupCustomerTypeTable";

import * as groupCustomerV2Api from '../../../../api/groupCustomerV2/groupCustomerV2Api';
import { formatNumber } from "../../../../services/mixin";
import { selectorCategoryCarIds } from "../../../../store/slices/categoryCarSlice";

interface DataType {
  key: React.Key;
  stt: number;
  nameGroup: string;
  typeGroup: string;
  unit: Item[];
  tag: Item[];
  cout: number;
  userCreate: string;
  dateCreate: string
}

const RecycleGroupCustomer: React.FC = () => {
  const { Search } = Input;
  const pushLoading = useLoading()
  const pushToast = useToast()
  const navigate = useNavigate()
  const { unitTemp } = useSelector(selectorInfoUser)
  const permittedCategoryCarIds = useSelector(selectorCategoryCarIds)

  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [selectedIdGroup, setSelectedIdGroup] = useState<Set<Number>>(new Set());

  const [paginationTmp, setPaginationTmp] = useState<number>(1)
  const [pagination, setPagination] = useState({ current: 1, pageSize: 15, total: 0 });
  const [search, setSearch] = useState<string>("")
  const [openRestoreListGroupCustomer, setOpenRestoreListGroupCustomer] = useState(false)
  const [openDeleteListGroupCustomer, setOpenDeleteListGroupCustomer] = useState(false)
  const [isExpanded, setIsExpanded] = useState<number>();

  const [idRecycleGroupCustomer, setIdRecycleGroupCustomer] = useState<number[]>([])

  const [listRecycleGroupCustomer, setListRecycleGroupCustomer] = useState<groupCustomerV2Api.IGroupTypeList[]>([])

  const gListRecycleGroupCustomer = useDebounce(async (pageSize: number = 15, pageCurent: number = 1,) => {
    pushLoading(true)
    const result = await getListRecycleGroupCustomer(
      permittedCategoryCarIds,
      pageSize, pageCurent, unitTemp ?? undefined, search
    )
    if (result?.status) {
      setListRecycleGroupCustomer(result.data)
      setPagination({ current: pageCurent, total: result.total, pageSize })
      setPaginationTmp(pageCurent)
    } else {
      pushToast(result?.message, "warning")
    }
    pushLoading(false)
  }, 1000)

  const openModalRestoreGroupListCustomer = (id: number[]) => {

    setIdRecycleGroupCustomer(id)
    setOpenRestoreListGroupCustomer(true)
  }

  const closeModalRestore = () => {
    setIdRecycleGroupCustomer([])
    setOpenRestoreListGroupCustomer(false)
  }

  const onConfirmRestore = async () => {
    const selectedGroupCustomer = Array.from(selectedIdGroup).map((item) => Number(item))
    const result = await recycleCustomerApi.restoreGroupCustomer(selectedGroupCustomer)
    if (result?.status) {
      gListRecycleGroupCustomer(pagination.pageSize, pagination.current)
      pushToast(result.message, "success")
      closeModalRestore()
      setSelectedRowKeys([])
    } else {
      pushToast(result?.message, "warning")
    }
  }

  const openModalDeleteListGroupCustomer = (id: number[]) => {
    setIdRecycleGroupCustomer(id)
    setOpenDeleteListGroupCustomer(true)
  }

  const closeModalDelete = () => {
    setIdRecycleGroupCustomer([])
    setOpenDeleteListGroupCustomer(false)
  }

  const onConfirmDelete = async () => {

    // if (!inforNodeEvent?.item?.key && !selectedIdGroup.size) return
    // const idGroup = selectedIdGroup.size ? Array.from(selectedIdGroup) : [Number(inforNodeEvent!.item!.key)]
    const idGroup = Array.from(selectedIdGroup)

    const result = await groupCustomerV2Api.deleteGroup(idGroup)
    if (result?.status) {
      pushToast(result.message, "success")
      closeModalDelete()
      gListRecycleGroupCustomer(pagination.pageSize, pagination.current)
    } else {
      pushToast(result?.message, "warning")
    }
  }

  const onPaginationChange: PaginationProps['onChange'] = (pageNumber, pageSize) => {
    setPaginationTmp(pageNumber);
    setPagination((prev) => ({ ...prev, current: pageNumber, pageSize }))
    gListRecycleGroupCustomer(pageSize, pageNumber)
  }
  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    preserveSelectedRowKeys: true,
  };

  const onChangeTB: TableProps<DataType>['onChange'] = (pagination, filters, sorter, extra) => {
  };

  useEffect(() => {
    gListRecycleGroupCustomer()
  }, [search, unitTemp])
  return (
    <div className="d-flex flex-column gap-18-px h-full">
      <ModalRestoreCustomer
        isOpen={openRestoreListGroupCustomer}
        title="Bạn có chắc chắn khôi phục nhóm khách hàng?"
        titleDelete="Khôi phục"
        content="Bạn có muốn khôi phục bản ghi đã chọn?"
        closeModal={closeModalRestore}
        onConfirm={onConfirmRestore}
      />
      <ModalDeleteManager
        isOpen={openDeleteListGroupCustomer}
        title="Bạn có chắc chắn xóa vĩnh viễn bản ghi?"
        titleDelete="Xoá vĩnh viễn"
        content="Bạn có chắc chắn muốn xóa vĩnh viễn bản ghi đã chọn?"
        closeModal={closeModalDelete}
        onConfirm={onConfirmDelete}
      />
      <div className="custom-page-css w-full flex items-center justify-between mb-4 filter-block">
        <div className='t-search-block-v1'>
          <Search
            placeholder="Tìm kiếm thông tin khách hàng"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
      </div>
      <div className="custom-page-css w-full flex items-center gap-2 mb-4 ">
        <img src={warning_delete} alt="" />
        <span className='custom-page-css text-base text-FA8C16'>Hệ thống sẽ tự động xóa bản ghi vĩnh viễn sau 30 ngày nếu không được khôi phục</span>
      </div>
      {
        selectedIdGroup.size > 0
        && (<div className="d-flex align-center gap-3">
          <span className="text-sm font-regular text-344054">Đã chọn {selectedIdGroup.size} khách hàng</span>
          <button className="d-flex align-center gap-2 rounded-6-px p-2 bg-white border-D0D5DD"
            onClick={() => setOpenRestoreListGroupCustomer(true)}
          >
            <RedoOutlined className="text-344054" />
            <span className="text-sm font-regular text-344054">Khôi phục nhóm khách hàng</span>
          </button>
          <button className="d-flex align-center gap-2 rounded-6-px p-2 bg-white border-D0D5DD"
            onClick={() => setOpenDeleteListGroupCustomer(true)}
          >
            <DeleteOutlined className="text-F5222D" />
            <span className="text-sm font-regular text-344054">Xoá nhóm khách hàng</span>
          </button>
        </div>)
      }
      <div className=" t-table-customer  custom-page-css flex flex-col flex-1 justify-between">
        <div className={`order-history-card__body custom-page-css flex flex-1 flex-col justify-between`}>
          <div className="ag-theme-alpine  custom-table-ag" >

            <RecycleGroupCustomerTypeTable
              selectedIdGroup={selectedIdGroup}
              dataTable={listRecycleGroupCustomer}
              // onAction={setInforNodeEvent}
              setSelectedIdGroup={setSelectedIdGroup}
              setOpenDeleteListGroupCustomer={setOpenDeleteListGroupCustomer}
              setOpenRestoreListGroupCustomer={setOpenRestoreListGroupCustomer}

            />
          </div>

          {/* Pagination */}
          <ConfigProvider locale={viVN}>
            <div className="pagination-block">
              <Pagination
                showSizeChanger
                current={pagination.current}
                pageSize={pagination.pageSize}
                total={pagination.total}
                itemRender={(page, type, originalElement) => {
                  // Chỉ custom khi là nút số trang
                  if (type === 'page') {
                    return <span>{formatNumber(page)}</span>;
                  }
                  // prev / next / jump-prev / jump-next giữ nguyên
                  return originalElement;
                }}
                showTotal={(total) => `Tổng cộng ${dataPagination(pagination.total, pagination.pageSize, pagination.current).totalPage} trang`}
                className='rs-pagination'
                onChange={onPaginationChange}
              />
            </div>
          </ConfigProvider>
        </div>
      </div>
    </div>
  )
}
export default RecycleGroupCustomer
